import { createSlice } from "@reduxjs/toolkit";
import {
    setLoadingAndError,
    setError
} from "../../components/common/slice_state";

import { createProject, getProjectById, getAllProjects } from '../Thunks/projectThunk'

const initialState = {
    projectArray : [],
    selectedProject : null,
    loading: false,
    error: null
}

export const projectSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
           
            .addCase(createProject.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createProject.fulfilled, (state, action) => {
                state.loading = false;

                if (!action.payload?.project_id) {
                    state.error = "No project_id returned from API";
                    return;
                }
                
                state.projectArray.push(action.payload);
            })
            .addCase(createProject.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(getAllProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllProjects.fulfilled, (state, action) => {
                state.loading = false;
                state.projectArray = action.payload;
            })
            .addCase(getAllProjects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Get project by ID
            .addCase(getProjectById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProjectById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedProject = action.payload;
            })
            .addCase(getProjectById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const projects = (state) => state.projects.projectArray;
export const selectedProject = (state) => state.projects.selectedProject;

export default projectSlice.reducer;